<template>
  <div>
    <b-card header="Opciones de Filtro" class="card-filter">
      <b-btn class="filter-collapse" 
          variant="primary" 
          size="sm"
          @click.prevent="showOpcionesFiltro= !showOpcionesFiltro">
        <i :class="showOpcionesFiltro ? 'fa fa-caret-up' : 'fa fa-caret-down'"></i>
      </b-btn>
      <b-collapse id="filtro" class="mt-2" v-model="showOpcionesFiltro">
        <b-form>
          <b-form-group
            label="Nombre"
            label-for="nombre"
            :label-cols="labelCols"
            horizontal>
            <b-form-input 
              id="nombre" 
              v-model="filtro.nombre" 
              type="text">
            </b-form-input>
          </b-form-group>

          <app-rubro
            label="Rubro"
            labelOption="Todos los rubros"
            :nombre="rubroNombre"
            :lista="rubrosList"
            :label-cols="labelCols"
            :nullOption="true"
            :nullDisabled="false"
            @updated="rubroActualizado">
          </app-rubro>  

          <b-form-group
            :label-cols="labelCols"
            horizontal>
            <b-form-checkbox 
                id="incluirBienesPersonal"
                v-model="filtro.incluirBienesPersonal"
                :value="Boolean(true)"
                :unchecked-value="Boolean(false)">
                Incluir bienes en poder del personal
            </b-form-checkbox>
          </b-form-group>

          <app-personal
            :readOnly="!filtro.incluirBienesPersonal"
            label="Personal"
            labelOption="Todo el personal"
            :horizontal="Boolean(true)"
            :nullDisabled="Boolean(false)"
            :labelCols="labelCols"
            :nombre="personalNombre"
            :lista="personalList"
            @updated="personalActualizado">
          </app-personal>  
        </b-form>

        <div class="footer">
          <b-button size="sm" variant="primary" class="footer-button"
            @click.prevent="filtrar">Filtrar</b-button>
          <b-button size="sm" variant="primary" class="footer-button" 
            @click.prevent="limpiarFiltro">Limpiar</b-button>
        </div>
      </b-collapse>
    </b-card>
  </div>
</template>

<script>
import Rubro from '../shared/abmSelect.vue';
import Personal from '../shared/abmSelect.vue';

export default {
  components: {
    appRubro: Rubro,
    appPersonal: Personal
  },
  props: {
    nombre: {
      type: String,
      default: ''
    },
    rubro: {
      type: Object,
      default: null
    },
    personal: {
      type: Object,
      default: null
    },
    incluirBienesPersonal: {
      type: Boolean,
      default: true
    },
  },
  data() {
    return {
      filtro: {
        nombre: '',
        rubro: null,
        personal: null,
        incluirBienesPersonal: true,
      },
      rubros: [],
      rubrosList: [],
      personel: [],
      personalList: [],

      showOpcionesFiltro: Boolean(false),
      labelCols: 1
    }
  },
  computed: {
    rubroNombre() {
      if (this.filtro.rubro) {
        return this.filtro.rubro.nombre? this.filtro.rubro.nombre.trim() : null;
      }

      return null;
    },
    personalNombre() {
      if (this.filtro.personal) {
        return this.filtro.personal.nombre? this.filtro.personal.nombre.trim() : null;
      }

      return null;
    },

  },     
  created() {
    this.filtro.nombre = this.nombre.trim();
    this.filtro.rubro = this.rubro;
    this.filtro.personal = this.personal;
    this.filtro.incluirBienesPersonal = this.incluirBienesPersonal;
    
    this.getDatosAdicionales();
  },
  methods: {
    getDatosAdicionales() {
      this.$store.dispatch('bienesRubros/getList')
        .then(() => {
          this.rubros = this.$store.getters['bienesRubros/list'];
          this.rubrosList = this.$store.getters['bienesRubros/selectList'];
        })

      this.$store.dispatch('personel/getList', true)
        .then(() => {
          this.personel = this.$store.getters['personel/list'];
          this.personalList = this.$store.getters['personel/selectList'];
        })
    },    
    filtrar() {
      this.$emit('filtrar', this.filtro);
    },
    limpiarFiltro() {
      this.filtro.nombre = '';
      this.filtro.rubro = null;
      this.filtro.personal = null;
      this.filtro.incluirBienesPersonal = false;
    },
    rubroActualizado(rubroNombre) {
      if (rubroNombre != '') {
        this.filtro.rubro = this.getSelected(this.rubros, rubroNombre);
      } else {
        this.filtro.rubro = null;
      }
    },
    personalActualizado(personalNombre) {
      if (personalNombre != '') {
        this.filtro.personal = this.getSelected(this.personel, personalNombre);
      } else {
        this.filtro.personal = null;
      }
    },    
  },
}
</script>

<style>
</style>
